import React from 'react';
import { createPortal } from 'react-dom';
import CloseIcon from '../../../../SharedComponents/svg/Icons/CloseIcon';
import styles from './Modal.module.css';
import cn from 'classnames';
import { FCWithChildren } from '../../../../App.types';

export type ModalProps = {
    isOpen: boolean;
    closeOnOverlayClick?: boolean;
    onClose?: () => void;
    role?: string;
    ariaLabel?: string;
};

const Modal: FCWithChildren<ModalProps> = ({ isOpen, closeOnOverlayClick, onClose, children, role, ariaLabel }) => {
    const onOverlayClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();

        if (closeOnOverlayClick && typeof onClose === 'function') {
            onClose();
        }
    };

    if (!isOpen) {
        return null;
    }

    return createPortal(
        <div>
            <div className={styles.overlay} onClick={onOverlayClick} />
            <div role={role} aria-label={ariaLabel} className={styles.modal}>
                <CloseIcon width={14} height={14} className={styles.closeIcon} onClick={onClose} />
                {children}
            </div>
        </div>,
        document.body
    );
};

export const ModalTitle: FCWithChildren = ({ children }) => <p className={styles.title}>{children}</p>;

export const ModalFooter: FCWithChildren<{ align?: 'right' | 'left'; className?: string }> = ({
    children,
    align = 'right',
    className,
}) => (
    <div
        className={cn(styles.footer, className, {
            [styles.right]: align === 'right',
            [styles.left]: align === 'left',
        })}
    >
        {children}
    </div>
);

export const ModalContent: FCWithChildren<{ className?: string }> = ({ children, className }) => (
    <div className={cn(styles.content, className)}>{children}</div>
);

export default Modal;
